import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartRightStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-11 7.938V4.062a8.001 8.001 0 0 0 0 15.876ZM19.938 13A8.004 8.004 0 0 1 13 19.938V13h6.938Zm0-2H13V4.062A8.004 8.004 0 0 1 19.938 11Z"
    />
  </svg>
);
export default IconDrillingPartRightStrokedSizeM;
